import styled from "styled-components";

const SubsectionBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${({bg}) => bg};
    width: 100%;
    padding-bottom: 50px;
`;

export default SubsectionBlock;
